import * as rrd from 'react-router-dom';

const { useNavigate } = rrd.default ?? rrd;

const NewConversionButton = ({ onStartNew }) => {
  const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center mt-3">
      <div className="btn-group shadow-sm">
        <button
          type="button"
          onClick={onStartNew}
          className="btn btn-outline-custom btn-outline-accent d-flex align-items-center gap-2"
        >
          <i className="fas fa-rotate-right"></i>
          Start Another Conversion
        </button>

        <button
          type="button"
          aria-expanded="false"
          data-bs-toggle="dropdown"
          className="btn btn-outline-custom btn-outline-accent dropdown-toggle dropdown-toggle-split"
        >
          <span className="visually-hidden">Toggle Dropdown</span>
        </button>

        <ul className="dropdown-menu dropdown-menu-end border-accent">
          <li>
            <button
              onClick={() => navigate('/')}
              className="dropdown-item text-accent d-flex align-items-center gap-2"
            >
              <i className="fas fa-list"></i>
              Browse all converters
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NewConversionButton;
